import WithRender from "../../templates/ui/selectOption.html";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { v4 as uuidv4 } from "uuid";

import Select2 from "v-select2-component";

export default WithRender({
  components: { Select2 },
  computed: {
    ...mapGetters([
      "getSummary",
      "getMarginColor",
      "getLayoutType",
      "getHideSearchBoxInPoptext"
    ]),
    name: function () {
      return this.propsData.name;
    },
    options: function () {
      return this.propsData.values;
    },
    settings: function () {
      var multiple = 0;
      if (this.propsData.type && this.propsData.type == "multiple") {
        multiple = 1;
      }
      var hideOptions = {};
      if (this.getHideSearchBoxInPoptext) {
        hideOptions = { minimumResultsForSearch: -1 };
      }
      return { multiple, ...hideOptions };
    },
    value: {
      get: function () {
        return this.propsData.type && this.propsData.type == "multiple"
          ? this.propsData.selected
          : this.propsData.selected[0];
      },
      set: function (newValue) {
        this.setPageOption({
          value: newValue,
          layout: false,
          option: this.propsData.code,
          optionType: this.optionType
        });
      }
    },
    showColorPickerForOption: function () {
      return (
        this.value === "oie_margin_type_monochromatic" &&
        this.getLayoutType === "image_editor"
      );
    },
    getId: function () {
      return this.selectId + "_" + uuidv4();
    }
  },
  methods: {
    ...mapActions(["setPageOption"]),
    ...mapMutations(["changeMarginColor"]),
    proccessMarginColor: function (event) {
      this.changeMarginColor(event.target.value);
    }
    /*
    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, text }) {
      console.log({ id, text });
    }*/
  },
  props: ["propsData", "optionType", "selectId"]
});
